import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { InsertionCycle } from '@app/shared/models/insertion-cycle.model';
import { Line } from '@app/shared/models/line.model';
import { Log } from 'ng2-logger';
import { InsertionCyclesService } from '@app/core/services/insertion-cycles.service';

import * as _ from 'lodash';
import { PermissionService } from '@app/authentication/services/permission.service';

@Component({
  selector: 'app-line-insertion-cycles-form',
  templateUrl: './line-insertion-cycles-form.component.html',
  styleUrls: ['./line-insertion-cycles-form.component.scss']
})
export class LineInsertionCyclesFormComponent implements OnInit {
  _logger = Log.create(LineInsertionCyclesFormComponent.name);

  @Input() showValidations = false;

  private originalInsertionCycles: InsertionCycle[];
  public line: Line;
  public insertionCycleForm: UntypedFormGroup;
  public allInsertionCycles: InsertionCycle[] = [];

  get isFormValid() {
    return this.insertionCycleForm.valid;
  }

  static notEmpty(control: UntypedFormControl): { [s: string]: boolean } {
    if (control.value && !(control.value.length > 0)) {
        return {'picklist.atLeastOne': true};
    }
    return null;
  }

  value() {
    return {insertionCyclesIds: _.map(this.insertionCycleForm.controls.insertionCycles.value, 'id')};
  }

  constructor(private insertionCyclesService: InsertionCyclesService, private permissionService: PermissionService) { }

  ngOnInit() {
    this._logger.info("ngOnInit:: Preparing line insertion cycles form");
    this.insertionCycleForm = new UntypedFormGroup({
      insertionCycles: new UntypedFormControl([])
    });

    const insertionCyclesControl = this.insertionCycleForm.get('insertionCycles');
    insertionCyclesControl.setValidators(c => {
          return Validators.compose([LineInsertionCyclesFormComponent.notEmpty])(c);
      });
  }

  init(line: Line) {
    if (this.shouldRenderModifiers()) { this.getInsertionCyles(); }
    if (line) {
      this.line = line;
      this.loadFormValue();
    }
  }

  private loadFormValue() {
    if (!this.line) { return; }

    const { insertionCycles } = this.line;
    this.insertionCycleForm.setValue({ insertionCycles });
  }

  resetForm() {
    this._logger.info("resetForm:: Resetting line insertion cycles form", this.line);
    this.insertionCycleForm.reset();
  }

  getFormInsertionCycles() {
    this._logger.info("getFormInsertionCycles::", this.line);
    const formData = this.insertionCycleForm.getRawValue();
    return formData;
  }

  private getInsertionCyles() {
    return this.insertionCyclesService.getInsertionCycles().subscribe(
      (data: any) => {
          this._logger.info('getInsertionCyles:: API returned data', data);
          this.allInsertionCycles = data.items || [];
          this.originalInsertionCycles = _.cloneDeep(this.allInsertionCycles);
      },
      (error: any) => {
          this._logger.error('getInsertionCyles:: API returned error', error);
          this._logger.error(error);
      });
  }

  shouldRenderModifiers() {
    return this.permissionService.hasHasPermissionForFeature('MANAGE_LINES');
  }
}
